import { Component, EventEmitter, Output, ChangeDetectorRef, AfterViewInit } from "@angular/core";

interface MenuItem {
  name: string;
  areaId: number;
  iconName: string;
  iconPack: string;
  isSelected: boolean;
}

@Component({
  selector: "dashboard-toolbar",
  templateUrl: "dashboard-toolbar.component.html",
  styleUrls: ['dashboard-toolbar.component.css']
})
export class DashboardToolbarComponent implements AfterViewInit {

  @Output() areaChangedEvent = new EventEmitter<number>();

  @Output() loadedEvent = new EventEmitter();

  menuItems: MenuItem[] = [];

  get selectedMenuItem(): MenuItem {
    if (this.menuItems) {
      return this.menuItems.filter(q => q.isSelected)[0];
    }
  }

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.loadedEvent.emit();
  }

  addIcon(name: string, areaId: number, iconName: string, iconPack: string): MenuItem {
    const item = {
      name: name,
      areaId: areaId,
      iconName: iconName,
      iconPack: iconPack,
      isSelected: false
    };

    this.menuItems.push(item);

    this.cdr.detectChanges();

    return item;
  }

  changeArea(areaId: number) {

    this.selectedMenuItem.isSelected = false;

    const item = this.menuItems.filter(q => q.areaId === areaId)[0];

    item.isSelected = true;

    this.areaChangedEvent.emit(areaId);
  }
}
